import React from 'react';
import { Message } from '@/types/chat';
import StepMessage from './StepMessage';
import RegularMessage from './RegularMessage';
import ToolCallStream from './ToolCallStream';
import { FileText } from 'lucide-react';

interface MessageListProps {
  messages: Message[];
  onFeedback: (messageId: string, feedback: 'thumbs_up' | 'thumbs_down') => void;
  showSources?: boolean;
}

const MessageList = ({ messages, onFeedback, showSources = false }: MessageListProps) => {

  return (
    <>
      {messages.map((message) => (
        <div key={message.id} className="mb-4">
          {message.isStep ? (
            <StepMessage message={message} />
          ) : (
            <RegularMessage message={message} onFeedback={onFeedback} />
          )}
          
          {/* Tool calls are now only shown during streaming, not in final messages */}
          
          {!!showSources && message.sources && message.sources.length > 0 && (
            <div className="mt-2 ml-9">
              <div className="text-xs text-muted-foreground">
                <div className="flex items-center gap-1 mb-1">
                  <FileText className="w-3 h-3" />
                  <span>Tools Used:</span>
                </div>
                <ul className="list-disc list-inside space-y-1">
                  {message.sources.map((source, index) => (
                    <li key={index} className="truncate">
                      {source}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default MessageList;